import { CargoInTankItemBM } from '../../types/BusinessModel/CargoTempLog/CargoInTankItemBM';
import { CargoTemperatureLogDateBM } from '../../types/BusinessModel/CargoTempLog/CargoTemperatureLogDateBM';
import { CargoInTankItem } from '../../types/ViewModel/CargoTempLog/CargoInTankItem';
import { CargoTemperatureLogDate } from '../../types/ViewModel/CargoTempLog/CargoTemperatureLogDate';
import { formatQueryDateOnly } from '../../utils/aol/aolDateUtils';
import { getDateFromISO } from 'odfjell-date-time-utils/dateTimeUtils';
import { mapCargoTemperatureLogBms, mapCargoTemperatureLogs } from './CargoTempLogFactory';

/** Maps BM → VM: converts `commodityId` (API/backend name) to `productId` (frontend name). */
const mapCargoInTankItem = (bm: CargoInTankItemBM): CargoInTankItem => ({
    cargoNumber: bm.cargoNumber,
    isOnBoard: bm.isOnBoard,
    tankId: bm.tankId,
    tradeName: bm.tradeName,
    cargoTempCategory: bm.cargoTempCategory,
    productId: bm.commodityId,
});

/** Maps VM → BM: converts `productId` (frontend name) to `commodityId` (API/backend name). */
const mapCargoInTankItemBm = (vm: CargoInTankItem): CargoInTankItemBM => ({
    cargoNumber: vm.cargoNumber,
    isOnBoard: vm.isOnBoard,
    tankId: vm.tankId,
    tradeName: vm.tradeName,
    cargoTempCategory: vm.cargoTempCategory,
    commodityId: vm.productId,
});

export const mapCargoTempLogDate = (bm: CargoTemperatureLogDateBM): CargoTemperatureLogDate => {
    return {
        logDateId: bm.logDateId,
        imoNumber: bm.imoNumber,
        logDate: getDateFromISO(bm.logDate),
        isComplete: bm.isComplete,
        lastUpdatedUtc: bm.lastUpdatedUtc,
        lastUpdatedBy: bm.lastUpdatedBy,
        cargoInTankList: bm.cargoInTankList?.map(mapCargoInTankItem) ?? null,
        cargoTemperatureLog: bm.cargoTemperatureLog ? mapCargoTemperatureLogs(bm.cargoTemperatureLog) : null,
        isValidated: bm.isComplete,
    };
};

export const mapCargoTempLogDates = (bms: CargoTemperatureLogDateBM[], offlineCargoTempLogDates?: any[]): CargoTemperatureLogDate[] => {
    if (!bms) return [];

    addOfflineDataToCargoTempLogDates(bms, offlineCargoTempLogDates ?? []);

    return bms.map((bm) => mapCargoTempLogDate(bm));
};

export const mapCargoTempLogDateBm = (vm: CargoTemperatureLogDate): CargoTemperatureLogDateBM => {
    return {
        logDateId: vm.logDateId,
        imoNumber: vm.imoNumber,
        logDate: formatQueryDateOnly(vm.logDate),
        isComplete: vm.isComplete,
        lastUpdatedUtc: vm.lastUpdatedUtc,
        lastUpdatedBy: vm.lastUpdatedBy,
        cargoInTankList: vm.cargoInTankList?.map(mapCargoInTankItemBm) ?? null,
        cargoTemperatureLog: vm.cargoTemperatureLog ? mapCargoTemperatureLogBms(vm.cargoTemperatureLog) : null,
    };
};

export const mapCargoTempLogDateBms = (vms: CargoTemperatureLogDate[]): CargoTemperatureLogDateBM[] =>
    vms ? vms.map((vm) => mapCargoTempLogDateBm(vm)) : [];

const addOfflineDataToCargoTempLogDates = (bms: CargoTemperatureLogDateBM[], offlineCargoTempLogDates: any[]) => {
    offlineCargoTempLogDates.forEach((offlineCargoTempLogDate) => {
        const saveCargoTemperatureLogRequest = offlineCargoTempLogDate.saveCargoTemperatureLogRequest;

        if (saveCargoTemperatureLogRequest) {
            const cargoTemperatureLogResponse = saveCargoTemperatureLogRequest.response;
            const indexOfBM = bms.findIndex((bm) => bm.logDate === cargoTemperatureLogResponse.logDate);

            if (indexOfBM > -1) {
                bms[indexOfBM] = cargoTemperatureLogResponse;
            } else {
                bms.push(cargoTemperatureLogResponse);
            }
        }
    });
};
